export const base = '/dashboard';